import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'IndexLayout',
    component: () => import('@/layouts/index-layout.vue'),
    strict: true,
    children: [
      {
        path: '/',
        name: 'Index',
        component: () => import('@/pages/index.vue'),
        strict: true,
      },
    ],
  },

  {
    path: '/',
    name: 'CommonLayout',
    component: () => import('@/layouts/common-layout.vue'),
    strict: true,
    children: [
      { path: '/book', name: 'Book', component: () => import('@/pages/book.vue'), strict: true },
      { path: '/book/', redirect: '/book' },

      { path: '/sheet', name: 'Sheet', component: () => import('@/pages/sheet.vue'), strict: true },
      { path: '/sheet/', redirect: '/sheet' },

      // 通常の回答結果
      {
        path: '/sheet_completed',
        name: 'SheetCompleted',
        component: () => import('@/pages/sheet-completed.vue'),
        strict: true,
      },
      { path: '/sheet_completed/', redirect: '/sheet_completed' },

      // 管理者向け回答結果
      {
        path: '/sheet_result',
        name: 'SheetResult',
        component: () => import('@/pages/sheet-result.vue'),
        strict: true,
      },
      { path: '/sheet_result/', redirect: '/sheet_result' },

      {
        path: '/mypage',
        name: 'Mypage',
        component: () => import('@/pages/mypage.vue'),
        strict: true,
        meta: { requireAuth: true },
      },
      { path: '/mypage/', redirect: '/mypage' },

      { path: '/result', name: 'Result', component: () => import('@/pages/result.vue'), strict: true },
      { path: '/result/', redirect: '/result' },

      { path: '/start', name: 'Start', component: () => import('@/pages/start.vue'), strict: true },
      { path: '/start/', redirect: '/start' },

      { path: '/logged-out', name: 'LoggedOut', component: () => import('@/pages/logged-out.vue'), strict: true },
      { path: '/logged-out/', redirect: '/logged-out' },

      { path: '/:pathMatch(.*)*', name: 'Error', component: () => import('@/pages/error.vue') },
      {
        path: '/sampleform1',
        name: 'SampleForm1',
        component: () => import('@/pages/sample-form1.vue'),
        strict: true,
      },
      {
        path: '/sampleform2',
        name: 'SampleForm2',
        component: () => import('@/pages/sample-form2.vue'),
        strict: true,
      },
    ],
  },
]

export default routes
